<div class="flex justify-center items-center w-full">
  @if (media().isVideo) {
    @if (platformFeature() === EPlatformFeature.youtubeShort) {
      <app-embedded-video-player
        class="w-[964px] h-[542px]"
        [videoUrl]="media().url"
        [platform]="EPlatform.youtube"
        [autoPlay]="false"
        [seekToTime]="seekTime()"
      />
    } @else {
      <app-video-player
        class="w-[360px]"
        [configuration]="videoConfiguration()"
        [seekTime]="seekTime()"
        [protectHeight]="true"
        [videoPlayedContext]="videoPlayedContext"
      />
    }
  } @else {
    <img class="w-[360px] rounded-lg" [src]="media().thumbnail || media().url" alt="Image" />
  }
</div>
